import { Typography } from "@mui/material";
import Profile from "./Profile";

export default function Team() {
    const teamMembers = [
        {
            name: "Dr. Susu Zughaier",
            affiliation: "Associate Professor, Qatar University",
            photo: require("../../assets/dr-susu.jpg"),
        },
        {
            name: "Dr. Muhammad Chowdhury",
            affiliation: "Assistant Professor, Qatar University",
            photo: require("../../assets/dr-enamul.jpg"),
        },
        {
            name: "Prof. Yiping Zhao",
            affiliation: "Professor, University of Georgia",
            photo: require("../../assets/dr-zhao.jpeg"),
        },
        {
            name: "Yanjun Yang",
            affiliation: "PhD Candidate, University of Georgia",
            photo: require("../../assets/eng-yang.jpg"),
        },
        {
            name: "M.D Mahmoud Elgamal",
            affiliation: "Research Assistant, Qatar University",
            photo: require("../../assets/eng-mahmoud.jpg"),
        },
        {
            name: "Nabil Ibtehaz",
            affiliation: "PhD Candidate, Purdue University",
            photo: require("../../assets/eng-nabil.jpg"),
        },
        {
            name: "Md. Sakib Abrar Hossain",
            affiliation: "Research Assistant, Qatar University",
            photo: require("../../assets/eng-sakib.jpg"),
        },
        {
            name: "Md. Ahasan Atick Faisal",
            affiliation: "Research Assistant, Qatar University",
            photo: require("../../assets/eng-atick.jpg"),
        },
    ];

    return (
        <div id="team" className="Team">
            <Typography variant="h2">THE <b>TEAM</b> MEMBERS</Typography>
            <div className="Container">
                {teamMembers.map((profile, idx) => (
                    <Profile key={idx} profile={profile} />
                ))}
            </div>
        </div>
    );
}
